// Identify a date object
export function isDate(x: unknown): x is Date {
  return Object.prototype.toString.call(x) === '[object Date]';
}

// Identify a regular expression object
export function isRegExp(x: unknown): x is RegExp {
  return Object.prototype.toString.call(x) === '[object RegExp]';
}

// Identify that something is a record (not an array, not
// a date, and not a regular expression)
export function isRecord(x: unknown): x is Record<string, unknown> {
  return typeof x === 'object' && !Array.isArray(x) && !isDate(x) && !isRegExp(x) && x !== null;
}

// Check if current context has browser window/document objects
export function isSSR(): boolean {
  return Boolean(typeof window === 'undefined' || !window.document);
}
